import { useState } from "react";
import BarChartComponent from "../charts/barChats/BarChartComponent";
import UniversalModal from "../modal/universalModal";
import PieChartGeneric from "../charts/GenericPieChart/PieCharts";
import RadialChart from "../charts/RadiaChart/radialChart";
import BarChartGeneric from "../charts/genericBar/BarChartGeneric";

const ECommerceDashboard = ({ chartData }) => {
  const { totalDocs, currentMonth, brands, site, seller, reporting } =
    chartData;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modelType, setModalType] = useState(null);

  const handleOpenModal = (type) => {
    setIsModalOpen(true);
    setModalType(type);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalType(null);
  };

  return (
    <>
      <div className="container" style={{ width: "100%" }}>
        <div
          className="row card-body p-0 text-center"
          style={{
            height: "100%",
            minHeight: "450px",
            width: "100%",
            margin: "auto",
          }}
        >
          {/* <div className="col-12 col-md-6 p-2">
            <PieChartGeneric
              data={brands}
              title="Brands - Distribution"
              totalDocs={Object.entries(brands)?.length || 0}
              openModel={() => handleOpenModal("brands")}
              centerText="Platforms"
            />
          </div> */}

          <div className="col-12 col-md-6 p-2">
            <PieChartGeneric
              data={site}
              title="Platform Distribution"
              totalDocs={totalDocs}
              openModel={() => handleOpenModal("site")}
              centerText="Infringement"
            />
          </div>
          <div className="col-12 col-md-6 p-2 text-center">
            <RadialChart
              currentMonthData={currentMonth}
              openModel={() => handleOpenModal("total")}
              title="Enforcement Percentage"
              subTitle="(All infringements - Awaiting approval- No Action) / All infringements"
              currentMonth={currentMonth}
            />
          </div>
        </div>
        <div
          className="row card-body p-0 text-center"
          style={{
            height: "100%",
            minHeight: "450px",
            width: "100%",
            margin: "auto",
          }}
        >
          <BarChartComponent
            title="E-Commerce Infringement by Reporting Date"
            data={reporting}
            openModel={() => handleOpenModal("Reporting")}
            reporting={true}
          />
        </div>

        <div
          className="row card-body p-0 text-center"
          style={{
            height: "100%",
            minHeight: "450px",
            width: "100%",
            margin: "auto",
          }}
        >
          <BarChartGeneric
            title="Platform Seller Distribution"
            data={seller}
            openModel={() => handleOpenModal("seller")}
            xLabel={`Sellers ${
              seller.length >= 49 ? "(only the top 50 data points shown)" : ""
            }`}
          />
        </div>
      </div>

      {/* modal */}
      <UniversalModal
        title={
          modelType === "Reporting"
            ? "E-Commerce Infringement by Reporting Date"
            : modelType === "brands"
            ? "Brands Distribution"
            : modelType === "site"
            ? "Webpage Distribution"
            : modelType === "seller"
            ? "Platform Seller Distribution"
            : modelType === "total"
            ? "Enforcement Percentage = (All infringements - Awaiting approval- No Action) / All infringements"
            : ""
        }
        body={
          <div
            className="card-body p-0 text-center"
            style={{ height: "100%", minHeight: "500px" }}
          >
            {modelType === "Reporting" && (
              <BarChartComponent
                data={reporting}
                modal={true}
                reporting={true}
              />
            )}
            {modelType === "brands" && (
              <PieChartGeneric data={brands} modal={true} totalDocs={0} />
            )}
            {modelType === "site" && (
              <PieChartGeneric data={site} modal={true} totalDocs={totalDocs} />
            )}
            {modelType === "seller" && (
              <BarChartGeneric data={seller} modal={true} />
            )}
            {modelType === "total" && (
              <RadialChart
                currentMonthData={currentMonth}
                modal={true}
                currentMonth={currentMonth}
              />
            )}
          </div>
        }
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        size="xl"
        centered={true}
      />
    </>
  );
};

export default ECommerceDashboard;
